import {
  useRef,
} from 'react';
import { FixedSizeGrid as Grid } from 'react-window';
import AutoSizer from 'react-virtualized-auto-sizer';
import {
  TextArea2,
} from './UtilComponents';
import {
  useGlobalStateSelector,
  words,
} from './globalState';
import { copyToClipboard } from 'utils/utilsBrowser';
import {
  addCardToDeck,
  removeCardFromDeck,
  handleClickEditCreatorInformation,
  resetCreatorInformationToRegisteredCard,
} from './monadomCore';
import {
  getSecretsFromNfc,
  getSecretsFromKeyCardRecords,
  keepKeyPairsAndSubAddressesInMemory,
} from './keysAndSigning';
import { useNfcrwScan } from './nativeAppHooks';
import { NativeAppReadButton } from './NativeAppUI';
import { handleClickScanQr } from './utils';
import iconInput from './input_circle_FILL0_wght400_GRAD0_opsz48.svg';
import iconOutput from './output_circle_FILL0_wght400_GRAD0_opsz48.svg';
import iconEdit from './edit_FILL0_wght400_GRAD0_opsz48.svg';
import iconShare from './share_FILL0_wght400_GRAD0_opsz48.svg';
import iconDetail from './more_horiz_FILL0_wght400_GRAD0_opsz48.svg';
import logoMonacotto from './logoMonacotto.png';
import iconCotto from './cotto.png';
import iconCopy from './content_copy_FILL0_wght400_GRAD0_opsz48.svg';
import iconKeyPool from './image/key_24dp_000000_FILL0_wght400_GRAD0_opsz24.svg';
import iconKeyCard from './playing_cards_FILL0_wght400_GRAD0_opsz24.svg';
import iconQr from './qr_code_2_FILL0_wght400_GRAD0_opsz24.svg';
import iconMpurse from './mpurse.png';
import iconSettings from './image/settings_24dp_000000_FILL0_wght400_GRAD0_opsz24.svg';

// SCORE
function Score(props) {
  let scores = [];
  let scoresSP = [];

  // if (props.side === 'A') {
  //   for (let i = 1; i <= state.duel.pointA; i++) {
  //     scores.push( <img className='size2x2 backgroundColorTransparent marginSide0p2' src={roseRed} /> );
  //   }
  // }
  // else { // B
  //   for (let i = 1; i <= state.duel.pointB; i++) {
  //     scores.push( <img className='size2x2 backgroundColorTransparent marginSide0p2' src={roseBlue} /> );
  //   }
  // }

  for (let i = 1; i <= props.point; i++) {
    scores.push( <img className='size2x2 backgroundColorTransparent marginSide0p2' src={props.src} alt='score' /> );
    scoresSP.push( <img className='size1p7x1p7 backgroundColorTransparent marginSide0p2' src={props.src} alt='score' /> );
  }

  return (
    <div>
      {/* PC */}
      <div className="visibleMiddleOrMore">
        <div className=''>
          { scores }
        </div>
      </div>
      {/* SP */}
      <div className="flexColumn visibleSmallOrLess ">
        <div className=''>
          { scoresSP }
        </div>
      </div>
    </div>
  );
}

function DuelSettingsButton({ popupLayer }) {
  const dispatch = useGlobalStateSelector(({ dispatch }) => dispatch);
  const popupLayerNext = popupLayer !== undefined && popupLayer !== null ? (popupLayer + 1) : 0;

  const handleClick = () => {
    const popup = { type: 'duelSettingsPopup' };
    dispatch({ type: 'setStateMultiLayers', keys: ['popup', popupLayerNext], value: popup });
  };

  return (
    <button className='button1'
      onClick={handleClick}
    >
      <img className='size2x2' src={iconSettings} alt='settings' />
    </button>
  );
}

// ITEM
function Item(props) {
  const state = useGlobalStateSelector(({ state }) => state);
  const dispatch = useGlobalStateSelector(({ dispatch }) => dispatch);
  const item = props.item;
  const quantity = props.quantity;
  const arrows = props.arrows;
  const popupLayerNext = props.popupLayer !== undefined ? props.popupLayer + 1 : 0;

  if (Object.keys(state.registeredCard).length === 0) {
    return null;
  }

  let cardImageUrl;
  let cardImageUrlSP;

  if (process.env.REACT_APP_ENVIRONMENT === 'prod') {
    // PCのデッキ用にmediumを用意してもよし。
    // cardImageUrl = `https://knightsofmonadom.monatoka.com/monacard/${item.asset}.png`;
    cardImageUrl = `https://knightsofmonadom.monatoka.com/monacard/small/${item.asset}_small.png`;
    cardImageUrlSP = `https://knightsofmonadom.monatoka.com/monacard/small/${item.asset}_small.png`;
  }
  else { // dev
    // PCのデッキ用にmediumを用意してもよし。
    // cardImageUrl = `https://dev.knightsofmonadom.monatoka.com/monacard/${item.asset}.png`;
    cardImageUrl = `https://dev.knightsofmonadom.monatoka.com/monacard/small/${item.asset}_small.png`;
    cardImageUrlSP = `https://dev.knightsofmonadom.monatoka.com/monacard/small/${item.asset}_small.png`;
  }

  let styleBox;
  let styleCard;

  if (props.size === 'small') {
    styleBox = 'boxCardSmall width14 ';
    styleCard = 'cardImageSmall';
  }
  else {
    styleBox = 'boxCard';
    styleCard = 'cardImage';
  }

  let styleBoxColor = '';
  let styleBorderColorSp = '';

  if (state.registeredCard[item.asset].category === 'magic') {
    styleBoxColor = ' backgroundColorLightGreen';
    styleBorderColorSp = ' borderDeepGreen';
  }
  else {
  }

  styleBox += styleBoxColor;


  return (
    <div>
      {/* PC */}
      <div className="visibleMiddleOrMore">
        <button className={styleBox} disabled={props.disabled ? true : false}
          onClick={ () => {
            const body = {
              monster: {
                asset: item.asset, 
              },
            };

            const popup = { type: 'monsterDetail', body: body };
            dispatch({ type: 'setStateMultiLayers', keys: ['popup', popupLayerNext], value: popup });
          }}
        >
          <div className='flexColumn justifyContentFlexStart alignItemsCenter'>
            <div className='relative' >
              <img className={styleCard} src={cardImageUrl} alt={item.asset} />
              { arrows === true ? <Arrows item={item} /> : null }
            </div>
            <div className='flexRow justifyContentFlexStart textCenter '>
              <CardName item={item} />
            </div>
            { quantity === true ? <Quantity item={item} /> : null }
          </div>
        </button>
      </div>
      {/* SP */}
      <div className="flexColumn visibleSmallOrLess ">
        <button className={'boxCardSP padding0p5' + styleBoxColor + styleBorderColorSp} disabled={props.disabled ? true : false}
          onClick={ () => {
            const body = {
              item: item,
              actionBox: (arrows === true ? 'switch' : 'close'),
            };

            const popup = { type: 'itemDetailSP', body: body };
            dispatch({ type: 'setStateMultiLayers', keys: ['popup', popupLayerNext], value: popup });
          }}
        >
          <div className='flexColumn justifyContentFlexStart alignItemsCenter'>
            <div className='relative' >
              <img className='cardImageSmallSP' src={cardImageUrlSP} alt={item.asset} />
            </div>
            { quantity === true ? <Quantity item={item} /> : null }
          </div>
        </button>
      </div>
    </div>
  );
}

// ARROWS
function Arrows(props) {
  const state = useGlobalStateSelector(({ state }) => state);
  const dispatch = useGlobalStateSelector(({ dispatch }) => dispatch);

  const item = props.item;
  let addressMain;

  if (state.active.addressMain !== undefined) {
    addressMain = state.active.addressMain;
  }
  else {
    return null;
  }

  if ( state.session[addressMain] !== undefined && state.session[addressMain].expirationOfSession > Date.now() ) {
    return (
      <div>
        <button className='z200TopRight flexRow justifyContentCenter alignItemsCenter size2x2Large backgroundColorTransparent borderNone cursor borderRadiusCircle riseOut2Half '
          onClick={ (e) => {
            e.stopPropagation();
            addCardToDeck(state, dispatch, item);
          }}
        >
          <img className='size2x2' src={iconInput} alt='input' />
        </button>
        <button className='z200BottomRight flexRow justifyContentCenter alignItemsCenter size2x2Large backgroundColorTransparent borderNone cursor borderRadiusCircle riseOut2Half '
          onClick={ (e) => {
            e.stopPropagation();
            removeCardFromDeck(state, dispatch, item.asset);
          }}
        >
          <img className='size2x2' src={iconOutput} alt='output' />
        </button>
      </div>
    );
  }
  else {
    return null;
  }
}

// CARD NAME
function CardName(props) {
  const state = useGlobalStateSelector(({ state }) => state);

  const item = props.item;

  if (state.registeredCard[item.asset] !== undefined) {
    return (
      <div className='textCenter '>
        { state.registeredCard[item.asset].name }
      </div>
    );
  }
  else {
    return null;
  }
}

// QUANTITY
function Quantity(props) {
  const state = useGlobalStateSelector(({ state }) => state);

  const item = props.item;
  let addressMain;
  let deckSet;

  if (state.active.addressMain !== undefined && state.deckSet[state.active.addressMain] !== undefined) {
    addressMain = state.active.addressMain;
    deckSet = state.deckSet[addressMain];
  }
  else {
    return null;
  }

  const quantityInCurrentDeck = deckSet.decks[deckSet.currentDeckNo].cards.filter( card => card.asset === item.asset ).length;


  return (
    <div className='flexRow justifyContentCenter '>
      <div className=''>
        { item.quantity - quantityInCurrentDeck }
      </div>
      <div className=''>
        { ' / ' }
      </div>
      <div className=''>
        { item.quantity }
      </div>
    </div>
  );
}

// SELECT ACTION BOX
function SelectActionBox(props) {
  const state = useGlobalStateSelector(({ state }) => state);
  const dispatch = useGlobalStateSelector(({ dispatch }) => dispatch);
  const item = props.item;


  return (
    <div className='flexRow justifyContentSpaceAround widthMax'>
      <button className='button2 widthDiv3'
        onClick={ () => {
          addCardToDeck(state, dispatch, item);
          dispatch({ type: 'setStateMultiLayers', keys: ['popup', props.popupLayer], value: { type: null, body: null } });
        }}
      >
        <img className='size2x2' src={iconInput} alt='input' />
      </button>
      <button className='button2 widthDiv3'
        onClick={ () => {
          removeCardFromDeck(state, dispatch, item.asset);
          dispatch({ type: 'setStateMultiLayers', keys: ['popup', props.popupLayer], value: { type: null, body: null } });
        }}
      >
        <img className='size2x2' src={iconOutput} alt='output' />
      </button>
      <button className='button2 widthDiv3' onClick={ () => { dispatch({ type: 'setStateMultiLayers', keys: ['popup', props.popupLayer], value: { type: null, body: null } }); } }  >
        { words.close[state.language] }
      </button>
    </div>
  );
}

// CLOSE BOX
function CloseBox(props) {
  const state = useGlobalStateSelector(({ state }) => state);
  const dispatch = useGlobalStateSelector(({ dispatch }) => dispatch);


  return (
    <div className='flexRow justifyContentSpaceAround widthMax'>
      <button className='button2 widthDiv3' onClick={ () => { dispatch({ type: 'setStateMultiLayers', keys: ['popup', props.popupLayer], value: { type: null, body: null } }); } }  >
        { words.close[state.language] }
      </button>
    </div>
  );
}

// ITEM DETAIL SP
function ItemDetailSP(props) {
  const state = useGlobalStateSelector(({ state }) => state);
  const dispatch = useGlobalStateSelector(({ dispatch }) => dispatch);
  const popupLayer = props.popupLayer;

  let card = state.popup[popupLayer].body.card;

  if (card === undefined) {
    card = state.popup[popupLayer].body.item;
  }

  const item = card;

  const actionBox = state.popup[popupLayer].body.actionBox;
  const side = state.popup[popupLayer].body.side;
  const position = state.popup[popupLayer].body.position;
  const source = state.popup[popupLayer].body.source;
  const monstersInformationRevisedSingleSide = state.popup[popupLayer].body.monstersInformationRevisedSingleSide;
  const imageNoSingleSide = state.popup[popupLayer].body.imageNoSingleSide;
  // const information = state.registeredCard[card.asset];

  let cardImageUrl;
  let imageNo;

  // if (process.env.REACT_APP_ENVIRONMENT === 'prod') {
  //   cardImageUrl = `https://knightsofmonadom.monatoka.com/monacard/small/${item.asset}_small.png`;
  // }
  // else { // dev
  //   cardImageUrl = `https://dev.knightsofmonadom.monatoka.com/monacard/small/${item.asset}_small.png`;
  // }

  if (source === 'history') {
    imageNo = imageNoSingleSide;
  }
  else { // duel
    imageNo = state.duel.imageNo[side];
  }

  if (position === 'field' && imageNo !== undefined && imageNo !== 0) {
    cardImageUrl = `https://${process.env.REACT_APP_MONACARD_URL}small/${item.asset}_${imageNo}_small.png`;
  }
  else {
    cardImageUrl = `https://${process.env.REACT_APP_MONACARD_URL}small/${item.asset}_small.png`;
  }

  let actionBoxComponent;
  
  if (actionBox === 'switch') {
    actionBoxComponent = <SelectActionBox item={item} popupLayer={props.popupLayer} />;
  }
  else if (actionBox === 'close') {
    actionBoxComponent = <CloseBox popupLayer={props.popupLayer} />;
  }
  else {
    actionBoxComponent = null;
  }

  const popup = { type: 'creatorInformation', body: item };

  const editButton =
  <button className='button1'
    onClick={ () => {
      if (!state.creatorInformation[item.asset]?.editing) {
        resetCreatorInformationToRegisteredCard({ dispatch, asset: item.asset, registeredCard: state.registeredCard[item.asset] });
        dispatch({ type: 'setStateMultiLayers', keys: ['creatorInformation', item.asset, 'editing'], value: true });
      }

      dispatch({ type: 'setStateMultiLayers', keys: ['popup', props.popupLayer + 1], value: popup }); 
    }}
  >
    <img className='size2x2' src={iconEdit} alt='edit' />
  </button>;


  // 補正カード名

  let nameRevised;

  if (position === 'field') {
    if (source === 'history') {
      nameRevised = monstersInformationRevisedSingleSide?.name;
    }
    else {
      nameRevised = state.duel.monstersInformationRevised?.[side]?.name;
    }
  }

  // 補正プロフィール

  let featureRevised;

  if (position === 'field') {
    if (source === 'history') {
      featureRevised = monstersInformationRevisedSingleSide?.feature;
    }
    else {
      featureRevised = state.duel.monstersInformationRevised?.[side]?.feature;
    }
  }


  return (
    <div className='flexColumn alignItemsFlexStart widthMax marginTop0p5'>
      <div className='flexColumn alignItemsCenter widthMax'>
        <img className='cardImageFullWidth ' src={cardImageUrl} alt='card' />
      </div>
      { actionBoxComponent }
      <CardSpec card={card} nameRevised={nameRevised} featureRevised={featureRevised} popupLayer={popupLayer} />
      <div className='flexColumn alignItemsCenter widthMax' >
        <div className='flexColumn alignItemsFlexStart width98vw borderKOMFatBorder padding1 marginTop0p5'>
          <div className='flexRow alignItemsFlexEnd marginBottom0p5'>
            <div className='marginRight1'>
              { words.creater[state.language] }
            </div>
            <div className='font1p5'>
              { state.registeredCard[item.asset].creater }
            </div>
          </div>
          <textarea className='widthMax height15 backgroundColorTransparent borderKOM preWrap padding0p5 marginTopBottom1'
            value={ state.registeredCard[item.asset].createrText }
          />
          <div className='flexRow justifyContentFlexStart '>
            <MonacottoLink asset={item.asset}  />
            <CreaterLink asset={item.asset} index={0} />
            <CreaterLink asset={item.asset} index={1} />
            <CreaterLink asset={item.asset} index={2} />
          </div>
          <div className='flexRow justifyContentFlexEnd widthMax '>
            { editButton }
          </div>
        </div>
      </div>
    </div>
  );
}

// MONSTER DETAIL
function MonsterDetail(props) {
  const state = useGlobalStateSelector(({ state }) => state);
  const dispatch = useGlobalStateSelector(({ dispatch }) => dispatch);
  const popupLayer = props.popupLayer;

  let card = state.popup[popupLayer].body.card;

  // if (card === undefined) {
  //   card = state.popup[popupLayer].body.item;
  // }

  if (card === undefined) {
    card = state.popup[popupLayer].body.monster;
  }

  const side = state.popup[popupLayer].body.side;
  const position = state.popup[popupLayer].body.position;
  const source = state.popup[popupLayer].body.source;
  const monstersInformationRevisedSingleSide = state.popup[popupLayer].body.monstersInformationRevisedSingleSide;
  const imageNoSingleSide = state.popup[popupLayer].body.imageNoSingleSide;
  // const information = state.registeredCard[card.asset];

  // カードイメージ

  let cardImageUrl;
  let imageNo;

  // if (process.env.REACT_APP_ENVIRONMENT === 'prod') {
  //   cardImageUrl = `https://knightsofmonadom.monatoka.com/monacard/${card.asset}.png`;
  // }
  // else { // dev
  //   cardImageUrl = `https://dev.knightsofmonadom.monatoka.com/monacard/${card.asset}.png`;
  // }

  if (source === 'history') {
    imageNo = imageNoSingleSide;
  }
  else { // duel
    imageNo = state.duel.imageNo[side];
  }

  if (position === 'field' && imageNo !== undefined && imageNo !== 0) {
    cardImageUrl = `https://${process.env.REACT_APP_MONACARD_URL}${card.asset}_${imageNo}.png`;
  }
  else {
    cardImageUrl = `https://${process.env.REACT_APP_MONACARD_URL}${card.asset}.png`;
  }

  // クリエイター情報編集

  const popup = { type: 'creatorInformation', body: card };

  const editButton =
  <button className='button1'
    onClick={ () => {
      if (!state.creatorInformation[card.asset]?.editing) {
        resetCreatorInformationToRegisteredCard({ dispatch, asset: card.asset, registeredCard: state.registeredCard[card.asset] });
        dispatch({ type: 'setStateMultiLayers', keys: ['creatorInformation', card.asset, 'editing'], value: true });
      }

      dispatch({ type: 'setStateMultiLayers', keys: ['popup', props.popupLayer + 1], value: popup }); 
    }}
  >
    <img className='size2x2' src={iconEdit} alt='edit' />
  </button>;

  // 補正カード名

  let nameRevised;

  if (position === 'field') {
    if (source === 'history') {
      nameRevised = monstersInformationRevisedSingleSide?.name;
    }
    else {
      nameRevised = state.duel.monstersInformationRevised?.[side]?.name;
    }
  }

  // 補正プロフィール

  let featureRevised;

  if (position === 'field') {
    if (source === 'history') {
      featureRevised = monstersInformationRevisedSingleSide?.feature;
    }
    else {
      featureRevised = state.duel.monstersInformationRevised?.[side]?.feature;
    }
  }


  return (
    <div className='flexRow justifyContentCenter'>
      <div className=''>
        <img className='cardImageLarge marginSide1' src={cardImageUrl} alt='card' />
      </div>
      <div className='flexColumn alignItemsFlexStart cardImageLarge marginSide1'>
        <div className='flexColumn alignItemsFlexStart widthMax '>
          <CardSpec card={card} nameRevised={nameRevised} featureRevised={featureRevised} popupLayer={popupLayer} />
        </div>
        <div className='flexColumn alignItemsFlexStart widthMax borderKOMFatBorder padding1 marginTop0p5'>
          <div className='flexRow alignItemsFlexEnd marginBottom0p5'>
            <div className='marginRight1'>
              { words.creater[state.language] }
            </div>
            <div className='font1p5'>
              { state.registeredCard[card.asset].creater }
            </div>
          </div>
          <textarea className='widthMax height15 backgroundColorTransparent borderKOM preWrap padding0p5 marginTopBottom1'
            value={ state.registeredCard[card.asset].createrText }
          />
          <div className='flexRow justifyContentFlexStart '>
            <MonacottoLink asset={card.asset}  />
            <CreaterLink asset={card.asset} index={0} />
            <CreaterLink asset={card.asset} index={1} />
            <CreaterLink asset={card.asset} index={2} />
          </div>
          <div className='flexRow justifyContentFlexEnd widthMax '>
            { editButton }
          </div>
        </div>
      </div>
    </div>
  );
}

// CARD SPEC
function CardSpec(props) {
  const state = useGlobalStateSelector(({ state }) => state);
  const popupLayer = props.popupLayer;
  const card = props.card;
  const nameRevised = props.nameRevised;
  const featureRevised = props.featureRevised;
  const information = state.registeredCard[card.asset];

  // カード名補正

  let name = information.name;

  if (nameRevised !== undefined) {
    name = nameRevised;
  }

  // プロフィール補正

  let feature = information.feature;

  if (featureRevised !== undefined) {
    feature = featureRevised;
  }

  // エディション(レプリカ)
  let edition;

  if (information.edition === 'replica') {
    edition =
    <div className='marginSide0p5'>
      【OFFICIAL REPLICA】
    </div>;
  }

  // カードスペック

  let spec;

  if (information.category === 'magic') {

    // タイプ
    let typeText = '';

    if (information.preEffects !== undefined) {
      typeText = information.preEffects.reduce( (acc, cur) => {
        if (cur.type !== undefined && cur.type !== null && cur.type !== '') {
          return acc + words[cur.type][state.language] + ' ';
        }
        else {
          return acc;
        }
      },
      '');
    }

    if (typeText === '') {
      typeText = words.nothing[state.language];
    }

    // コスト
    let costText = '';

    if (information.costs !== undefined) {
      for (const cost of information.costs) {
        if (cost.type === 'discardCards') {
          if (cost.comparison === 'equal') {
            costText += words.discardCards01[state.language] + cost.amount + words.discardCards02[state.language];
          }
        }
        else if (cost.type === 'excludeCardsFromCemetery') {
          if (cost.comparison === 'equal') {
            costText += words.excludeCardsFromCemetery01[state.language] + cost.amount + words.excludeCardsFromCemetery02[state.language];
          }
        }
        else if (cost.type === 'excludeMonstersFromCemetery') {
          if (cost.comparison === 'equal') {
            costText += words.excludeMonstersFromCemetery01[state.language] + cost.amount + words.excludeMonstersFromCemetery02[state.language];
          }
        }
      }
    }

    if (costText === '') {
      costText = words.nothing[state.language];
    }

    // 排他
    let exclusionText = '';

    if (information.exclusions !== undefined) {
      for (const exclusion of information.exclusions) {
        if (exclusion.type === 'excludeOpponent') {
          exclusionText += exclusion.typesToExclude.reduce( (acc, cur) => acc + words[cur][state.language] + ' ', '');
        }
      }
    }

    if (exclusionText === '') {
      exclusionText = words.nothing[state.language];
    }

    spec =
    <div className='flexColumn alignItemsFlexStart widthMax padding0p5' >
      <div className='flexRow justifyContentSpaceBetween alignItemsFlexStart widthMax marginTopBottom1'>
        <div className=''>
          { words.magic[state.language] }
        </div>
        <div className='flexRow alignItemsCenter'>
          { edition }
          <ShareButton card={card} />
          <AssetInfoButton card={card} popupLayer={popupLayer} />
        </div>
      </div>
      <div className='flexColumn alignItemsFlexStart marginTopBottom1'>
        <div className=''>
          { words.name[state.language] }
        </div>
        <div className=''>
          { name }
        </div>
        <div className='preWrap marginTop1'>
          { information.flavorText }
        </div>
      </div>
      <div className='flexColumn alignItemsFlexStart marginTopBottom1'>
        <div className=''>
          { words.type[state.language] }
        </div>
        <div className='preWrap'>
          { typeText }
        </div>
      </div>
      <div className='flexColumn alignItemsFlexStart marginTopBottom1'>
        <div className=''>
          { words.effect[state.language] }
        </div>
        <div className='preWrap'>
          { information.effectText }
        </div>
      </div>
      <div className='flexColumn alignItemsFlexStart marginTopBottom1'>
        <div className=''>
          { words.cost[state.language] }
        </div>
        <div className='preWrap'>
          { costText }
        </div>
      </div>
      <div className='flexColumn alignItemsFlexStart marginTopBottom1'>
        <div className=''>
          { words.exclusion[state.language] }
        </div>
        <div className='preWrap'>
          { exclusionText }
        </div>
      </div>
      <div className='flexRow alignItemsCenter borderMonacotto marginTop1' >
        <div className='textCenter width2p4 height1p2' >
          { '0' }
        </div>
        {
          information.maginaThresholds.map( threshold =>
            <div className='textCenter width2p4 height1p2' >
              { threshold.face !== undefined ? threshold.face : threshold.upperBound }
            </div>
          )
        }
      </div>
    </div>
  }
  else { // monster
    spec =
    <div className='flexColumn alignItemsFlexStart widthMax padding0p5' >
      <div className='flexRow justifyContentSpaceBetween alignItemsFlexStart widthMax marginTopBottom1'>
        <div className=''>
          { words.knight[state.language] }
        </div>
        <div className='flexRow alignItemsCenter'>
          { edition }
          <ShareButton card={card} />
          <AssetInfoButton card={card} popupLayer={popupLayer} />
        </div>
      </div>
      <div className='flexColumn alignItemsFlexStart marginTopBottom1'>
        <div className=''>
          { words.name[state.language] }
        </div>
        <div className=''>
          { name }
        </div>
      </div>
      <div className='flexColumn alignItemsFlexStart marginTopBottom1'>
        <div className=''>
          { words.profile[state.language] }
        </div>
        <div className=''>
          { feature }
        </div>
      </div>
    </div>
  }

  return spec;
}

// SHARE BUTTON
function ShareButton(props) {
  const state = useGlobalStateSelector(({ state }) => state);
  const dispatch = useGlobalStateSelector(({ dispatch }) => dispatch);
  // const popupLayer = props.popupLayer;
  const card = props.card;

  const urlCardDetail = 'https://' + process.env.REACT_APP_KOM_EXTENSION_URL + `cardlist?asset=${card.asset}`;
  const textAreaRef = useRef(null);


  return (
    <div className='' >
      <button className='button1'
        onClick={ () => {
          navigator.clipboard.writeText(urlCardDetail)
          .then()
          .catch( err => {
            copyToClipboard(urlCardDetail, textAreaRef);
          });
          // dispatch({ type: 'setStateMultiLayers', keys: ['popup', popupLayer + 1], value: assetInfoPopup });

          dispatch({ type: 'setNotification', key: 'notification', value: words.urlHasBeenCopiedToTheClipboard[state.language] });
        }}
      >
        <img className='size2x2' src={iconShare} alt='share' />
      </button>
      <textarea ref={textAreaRef} style={{ position: 'absolute', left: '-9999px' }} ></textarea>
    </div>
  );
}

// ASSET INFO BUTTON
function AssetInfoButton(props) {
  const state = useGlobalStateSelector(({ state }) => state);
  const dispatch = useGlobalStateSelector(({ dispatch }) => dispatch);
  const popupLayer = props.popupLayer;
  const card = props.card;

  const assetInfoBody =
  <div className='flexColumn '>
    <div className='flexRow justifyContentSpaceBetween alignItemsCenter textCenter heightMin4 backgroundColorMonacottoAlmostWhite borderRadius0p3 margin0p5'  >
      <div className='marginSide1'>
        { words.cardNo[state.language] }
      </div>
      <div className='marginSide1'>
        { state.registeredCard[card.asset].cardNo }
      </div>
    </div>
    <div className='flexRow justifyContentSpaceBetween alignItemsCenter textCenter heightMin4 backgroundColorMonacottoAlmostWhite borderRadius0p3 margin0p5'  >
      <div className='marginSide1'>
        { words.asset[state.language] }
      </div>
      <div className='marginSide1'>
        { state.registeredCard[card.asset].asset }
      </div>
    </div>
    <div className='flexRow justifyContentSpaceBetween alignItemsCenter textCenter heightMin4 backgroundColorMonacottoAlmostWhite borderRadius0p3 margin0p5'  >
      <div className='marginSide1'>
        { words.asset_longname[state.language] }
      </div>
      <div className='marginSide1'>
        { state.registeredCard[card.asset].asset_longname }
      </div>
    </div>
  </div>

  const assetInfoPopup = { type: 'generalItems', body: assetInfoBody };

  return (
    <button className='button1' onClick={ () => { dispatch({ type: 'setStateMultiLayers', keys: ['popup', popupLayer + 1], value: assetInfoPopup }) } } >
      <img className='size2x2' src={iconDetail} alt='detail' />
    </button>
  );
}

// MONACOTTO LINK
function MonacottoLink(props) {
  const state = useGlobalStateSelector(({ state }) => state);
  const asset = props.asset;

  if (state.registeredCard[asset].monacottoLink?.url === undefined) {
    return null;
  }

  return (
    <div className='flexRow alignItemsCenter marginBottom0p5 marginSide0p5'>
      <button className='buttonMainColor widthMin10 height2p2 paddingSide1 flexRow justifyContentCenter alignItemsCenter ' tabindex='0' 
        onClick={ () => {
          window.open( state.registeredCard[asset].monacottoLink.url );
        }}
      >
        <img className='heightMax' src={logoMonacotto} alt='monacotto' />
        <img className='heightMax' src={iconCotto} alt='cotto' />
      </button>
      <button className='button1' tabindex='0' 
        onClick={ () => {
          navigator.clipboard.writeText( state.registeredCard[asset].monacottoLink.url )
          .then()
          .catch();
        }}
      >
        <img className='size2x2' src={iconCopy} alt='copy' />
      </button>
    </div>
  );
}

// CREATER LINK
function CreaterLink(props) {
  const state = useGlobalStateSelector(({ state }) => state);
  const asset = props.asset;
  const index = props.index;

  if (state.registeredCard[asset].createrLink?.[index] === undefined) {
    return null;
  }

  return (
    <div className='flexRow alignItemsCenter marginBottom0p5 marginSide0p5'>
      <button className='buttonMainColor widthMin10 height2p2 paddingSide1 textCenter flexRow justifyContentCenter alignItemsCenter ' tabindex='0' 
        onClick={ () => {
          window.open( state.registeredCard[asset].createrLink[index].url );
        }}
      >
        { state.registeredCard[asset].createrLink[index].title }
      </button>
      <button className='button1' tabindex='0' 
        onClick={ () => {
          navigator.clipboard.writeText( state.registeredCard[asset].createrLink[index].url )
          .then()
          .catch();
        }}
      >
        <img className='size2x2' src={iconCopy} alt='copy' />
      </button>
    </div>
  );
}

// DUEL TEXT
function DuelText(props) {
  const state = useGlobalStateSelector(({ state }) => state);
  const fontSizeClass = props.fontSizeClass;

  let prefield;
  let prefieldSp;

  if (state.duel.status === 'duelStandby') {
    prefield =
    <div className='prefield flexColumn justifyContentFlexStart padding0p5' >
      <div>
        { '<<フィールドの状況>>' } 
      </div>
      <div className='' >
        { state.duel.result[0].field }
      </div>
    </div>

    prefieldSp =
    <div className='prefieldSp flexColumn justifyContentFlexStart padding0p5 margin0p5' >
      <div>
        { '<<フィールドの状況>>' } 
      </div>
      <div className='' >
        { state.duel.result[0].field }
      </div>
    </div>
  }


  return (
    <>
      {/* PC */}
      <div className="visibleHuge">
        <div className='boxDuelTextBattleStory'>
          { state.duel.text + state.duel.chunks.join('') }
          { state.duel.straightManChunks.join('') }
          { prefield }
        </div>
      </div>
      {/* TABLET */}
      <div className="visibleLarge flexColumn alignItemsCenter">
        <div className={'boxDuelTextBattleStory boxDuelTextBattleStoryTablet ' + fontSizeClass} >
          { state.duel.text + state.duel.chunks.join('') }
          { state.duel.straightManChunks.join('') }
        </div>
        { prefieldSp }
      </div>
      {/* SP */}
      <div className="visibleMiddleOrLess flexColumn alignItemsCenter">
        <div className={'boxDuelTextBattleStory boxDuelTextBattleStorySP ' + fontSizeClass} >
          { state.duel.text + state.duel.chunks.join('') }
          { state.duel.straightManChunks.join('') }
        </div>
        { prefieldSp }
      </div>
    </>
  );
}

function FixedGrid({
  items,
  cellWidth = 200,
  cellHeight = 280,
  gap = 4,
  argToCellFunction,
  popupLayer,
  children,
}) {
  const state = useGlobalStateSelector(({ state }) => state);
  const dispatch = useGlobalStateSelector(({ dispatch }) => dispatch);


  return (
    <AutoSizer>
      {({ width, height }) => {
        // 画面幅から何列並べられるか
        const columnCount = Math.max( 1, Math.floor((width + gap) / (cellWidth + gap)) );

        // 必要な行数（高さからは決めず、画像枚数ベースで計算）
        const rowCount = Math.ceil(items.length / columnCount);

        return (
          <Grid
            width={width} height={height}
            columnWidth={cellWidth} rowHeight={cellHeight}
            columnCount={columnCount} rowCount={rowCount}
            itemData={{ state, dispatch, items, columnCount, gap, argToCellFunction, popupLayer }}
          >
            { children }
          </Grid>
        )
      }}
    </AutoSizer>
  )
}

// ITEM IN GRID
function itemInGrid({ columnIndex, rowIndex, style, data }) {
  const { state, dispatch, popupLayer, items, columnCount, gap, argToCellFunction } = data;
  const { quantity, arrows, boxWidth, cardWidth, disabled, device } = argToCellFunction;
  const index = rowIndex * columnCount + columnIndex;
  const popupLayerNext = popupLayer !== undefined && popupLayer !== null ? popupLayer + 1 : 0;

  if (index >= items.length) {
    return null;
  }

  const item = items[index];

  let cardImageUrl;
  let cardImageUrlSP;

  if (process.env.REACT_APP_ENVIRONMENT === 'prod') {
    // PCのデッキ用にmediumを用意してもよし。
    cardImageUrl = `https://knightsofmonadom.monatoka.com/monacard/small/${item.asset}_small.png`;
    cardImageUrlSP = `https://knightsofmonadom.monatoka.com/monacard/small/${item.asset}_small.png`;
  }
  else { // dev
    // PCのデッキ用にmediumを用意してもよし。
    cardImageUrl = `https://dev.knightsofmonadom.monatoka.com/monacard/small/${item.asset}_small.png`;
    cardImageUrlSP = `https://dev.knightsofmonadom.monatoka.com/monacard/small/${item.asset}_small.png`;
  }

  let styleBoxColor = '';
  let styleBorderColorSp = '';
  // let cardNameSection;
  let quantitySection;
  let arrowsSection;
  let actionBoxType;

  if (state.registeredCard[item.asset].category === 'magic') {
    styleBoxColor = ' backgroundColorLightGreen';
    styleBorderColorSp = ' borderDeepGreen';
  }

  if (quantity === true) {
    quantitySection = <Quantity item={item} />;
  }

  if (arrows === true) {
    arrowsSection = <Arrows item={item} />;
    actionBoxType = 'switch';
  }
  else {
    actionBoxType = 'close';
  }

  let cardBoxButton;

  if (device === 'sp') {
    cardBoxButton =
    <button className={'boxCardSP padding0p5' + styleBoxColor + styleBorderColorSp} style={{ width: boxWidth }} disabled={disabled ? true : false}
      onClick={ () => {
        const body = {
          item: item,
          actionBox: actionBoxType,
        };

        const popup = { type: 'itemDetailSP', body: body };
        dispatch({ type: 'setStateMultiLayers', keys: ['popup', popupLayerNext], value: popup });
      }}
    >
      <div className='flexColumn justifyContentFlexStart alignItemsCenter'>
        <div className='relative' >
          <img style={{ width: cardWidth }} src={cardImageUrlSP} alt={item.asset} />
        </div>
        { quantitySection }
      </div>
    </button>;
  }
  else { // PC
    cardBoxButton =
    <button className={'boxCardSmall ' + styleBoxColor} style={{ width: boxWidth }} disabled={disabled ? true : false}
      onClick={ () => {
        const body = {
          monster: {
            asset: item.asset, 
          },
        };

        const popup = { type: 'monsterDetail', body: body };
        dispatch({ type: 'setStateMultiLayers', keys: ['popup', popupLayerNext], value: popup });
      }}
    >
      <div className='flexColumn justifyContentFlexStart alignItemsCenter'>
        <div className='relative' >
          <img style={{ width: cardWidth }} src={cardImageUrl} alt={item.asset} />
          { arrowsSection }
        </div>
        <div className='flexRow justifyContentFlexStart textCenter '>
          <CardName item={item} />
        </div>
        { quantitySection }
      </div>
    </button>;
  }

  return (
    <div
      style={{
        ...style,
        padding: gap / 2,
        boxSizing: 'border-box',
      }}
    >
      { cardBoxButton }
    </div>
  );
}

// CREATOR INFORMATION
function CreatorInformation(props) {
  const state = useGlobalStateSelector(({ state }) => state);
  const dispatch = useGlobalStateSelector(({ dispatch }) => dispatch);
  const keyPairsInPoolAll = useGlobalStateSelector(({ state }) => state.keyPairs);
  const item = state.popup[props.popupLayer].body;
  const asset = item.asset;
  const language = state.language || 'english';
  const network = state.networkMona;
  const pass = state.config.clientParameters.specialMessage;
  const paths = state.configKB.clientParameters.paths;
  const periodToKeepKeyPairs = state.config.clientParameters.periodToKeepKeyPairs;

  // iPhone アプリでキーカードを読み、オーナーアドレスの鍵で署名して登録する
  const nfcrwScan = useNfcrwScan({
    enabled: state.walletType === 'nfcNative',
    language: state.language,
    onRecords: async ({ records }) => {
      let secrets;

      try {
        secrets = await getSecretsFromKeyCardRecords({ dispatch, pass, records, language, network });
      }
      catch {
        return;
      }

      const { mnemonic, keyPairs, addressMain } = secrets;

      try {
        await handleClickEditCreatorInformation(state, dispatch, item.asset, { keyPairs, keyPairsInPoolAll });
      }
      catch (error) {
      }

      const mnemonicRecords = [{ mnemonic, address: addressMain }];
      keepKeyPairsAndSubAddressesInMemory({ dispatch, mnemonicRecords, paths, periodToKeepKeyPairs, language, network });
    },
    onFailure: () => {
      dispatch({ type: 'setNotification', key: 'notification', value: words.failedToReadNfc[state.language] });
    },
  });

  // リセットボタン

  const resetButton =
  <div className='flexRow justifyContentCenter widthMax marginTop1'>
    <button className='button2 widthMin20 heightMin4 flexRow justifyContentCenter alignItemsCenter ' tabindex='0'
      onClick={ () => resetCreatorInformationToRegisteredCard({ dispatch, asset, registeredCard: state.registeredCard[asset] }) }
    >
      <div>
        {words.resetToRegisteredCard[state.language]}
      </div>
    </button>
  </div>

  // 登録ボタン

  let registerButton;

  if (state.walletType === 'mpurse') {
    registerButton =
    <div className='flexRow justifyContentCenter widthMax marginTop1'>
      <button className='buttonMainColor widthMin20 heightMin4 flexRow justifyContentCenter alignItemsCenter ' tabindex='0'
        onClick={ () => {
          handleClickEditCreatorInformation(state, dispatch, item.asset, { keyPairsInPoolAll });
        }}
      >
        <div>
          {words.signByOwnerAddressToRegister[state.language]}
        </div>
        <img className='size2x2' src={iconMpurse} alt='mpurse' />
      </button>
    </div>
  }
  else if (state.walletType === 'nfc') {
    registerButton =
    <div className='flexRow justifyContentCenter widthMax marginTop1'>
      <button className='buttonMainColor widthMin20 heightMin4 flexRow justifyContentCenter alignItemsCenter ' tabindex='0'
        onClick={ async () => {
          dispatch({ type: 'setNotification', key: 'notification', value: words.touchWithYourKeyCard[language] });
          const { mnemonic, keyPairs, addressMain } = await getSecretsFromNfc({ dispatch, pass, language, network });

          try {
            await handleClickEditCreatorInformation(state, dispatch, item.asset, { keyPairs, keyPairsInPoolAll });
          }
          catch (error) {
          }

          const mnemonicRecords = [{ mnemonic, address: addressMain }];
          keepKeyPairsAndSubAddressesInMemory({ dispatch, mnemonicRecords, paths, periodToKeepKeyPairs, language, network });
        }}
      >
        <div>
          {words.signByOwnerAddressToRegister[state.language]}
        </div>
        <div>
          <img className='size2x2' src={iconKeyCard} alt='keycard' />
        </div>
      </button>
    </div>
  }
  else if (state.walletType === 'nfcNative') {
    registerButton =
    <div className='flexRow justifyContentCenter widthMax marginTop1'>
      <NativeAppReadButton
        nfcrwScan={nfcrwScan}
        intent='keycard'
        marginTop={false}
        face={
          <>
            <div>
              {words.signByOwnerAddressToRegister[state.language]}
            </div>
            <div>
              <img className='size2x2' src={iconKeyCard} alt='keycard' />
            </div>
          </>
        }
      />
    </div>
  }
  else if (state.walletType === 'qr') {
    registerButton =
    <div className='flexRow justifyContentCenter widthMax marginTop1'>
      <button className='buttonMainColor widthMin20 heightMin4 flexRow justifyContentCenter alignItemsCenter ' tabindex='0'
        onClick={ () => {
          const callback = (keyPairs) => handleClickEditCreatorInformation(state, dispatch, item.asset, { keyPairs, keyPairsInPoolAll });
          handleClickScanQr(state, dispatch, callback, { popupLayer: props.popupLayer + 1 });
        }}
      >
        <div>
          {words.signByOwnerAddressToRegister[state.language]}
        </div>
        <div>
          <img className='size2x2' src={iconQr} alt='qr' />
        </div>
      </button>
    </div>
  }
  else {
    registerButton =
    <div className='flexRow justifyContentCenter widthMax marginTop1'>
      <button className='buttonMainColor widthMin20 heightMin4 flexRow justifyContentCenter alignItemsCenter ' tabindex='0'
        onClick={ () => {
          handleClickEditCreatorInformation(state, dispatch, item.asset, { keyPairsInPoolAll });
        }}
      >
        <div>
          {words.signByOwnerAddressToRegister[state.language]}
        </div>
        <img className='size2x2' src={iconKeyPool} alt='key' />
      </button>
    </div>
  }

  return (
    <div>
      {/* PC */}
      <div className="visibleMiddleOrMore flexColumn alignItemsCenter">
        <div className='flexColumn alignItemsFlexStart borderKOM marginSide1 marginTop1 padding0p5'>
          {/* asset */}
          <div className='margin1'>
            { item.asset }
          </div>
          {/* creater */}
          <TextArea2 fieldName='creatorInformationCreater' keys={['creatorInformation', asset, 'creater']} face={words.creater[state.language]}
            boxClass='box4 height4 margin1 ' textAreaClass='textArea1 height70PC'
          />
          {/* createrText */}
          <TextArea2 fieldName='creatorInformationCreaterText' keys={['creatorInformation', asset, 'createrText']} face={words.createrText[state.language]}
            boxClass='box4 margin1' textAreaClass='textArea1'
          />
          {/* monacottoAddressMain */}
          <TextArea2 fieldName='creatorInformationMonacottoAddressMain' keys={['creatorInformation', asset, 'monacottoAddressMain']}
            face={words.monacottoAddressMain[state.language]} boxClass='box4 height4 margin1 ' textAreaClass='textArea1 height70PC'
          />
          {/* createrLink */}
          <TextArea2 fieldName='creatorInformationCreaterLink0Title' keys={['creatorInformation', asset, 'createrLink', 0, 'title']} face={words.createrLinkTitle[state.language] + 1}
            boxClass='box4 height4 margin1 ' textAreaClass='textArea1 height70PC'
          />
          <TextArea2 fieldName='creatorInformationCreaterLink0Url' keys={['creatorInformation', asset, 'createrLink', 0, 'url']} face={words.createrLinkUrl[state.language] + 1}
            boxClass='box4 height4 margin1 ' textAreaClass='textArea1 height70PC'
          />
          <TextArea2 fieldName='creatorInformationCreaterLink1Title' keys={['creatorInformation', asset, 'createrLink', 1, 'title']} face={words.createrLinkTitle[state.language] + 2}
            boxClass='box4 height4 margin1 ' textAreaClass='textArea1 height70PC'
          />
          <TextArea2 fieldName='creatorInformationCreaterLink1Url' keys={['creatorInformation', asset, 'createrLink', 1, 'url']} face={words.createrLinkUrl[state.language] + 2}
            boxClass='box4 height4 margin1 ' textAreaClass='textArea1 height70PC'
          />
          <TextArea2 fieldName='creatorInformationCreaterLink2Title' keys={['creatorInformation', asset, 'createrLink', 2, 'title']} face={words.createrLinkTitle[state.language] + 3}
            boxClass='box4 height4 margin1 ' textAreaClass='textArea1 height70PC'
          />
          <TextArea2 fieldName='creatorInformationCreaterLink2Url' keys={['creatorInformation', asset, 'createrLink', 2, 'url']} face={words.createrLinkUrl[state.language] + 3}
            boxClass='box4 height4 margin1 ' textAreaClass='textArea1 height70PC'
          />
          {/* reset button */}
          { resetButton }
          {/* register button */}
          { registerButton }
        </div>
      </div>
      {/* SP */}
      <div className="visibleSmallOrLess flexColumn alignItemsFlexStart widthMax padding1">
        {/* asset */}
        <div className=''>
          { item.asset }
        </div>
        {/* creater */}
        <TextArea2 fieldName='creatorInformationCreater' keys={['creatorInformation', asset, 'creater']} face={words.creater[state.language]}
          outerClass='widthMax' boxClass='box4 width96PC height4 marginTop1 ' textAreaClass='textArea1 height70PC'
        />
        {/* createrText */}
        <TextArea2 fieldName='creatorInformationCreaterText' keys={['creatorInformation', asset, 'createrText']} face={words.createrText[state.language]}
          outerClass='widthMax' boxClass='box4 width96PC marginTop1 ' textAreaClass='textArea1 '
        />
        {/* monacottoAddressMain */}
        <TextArea2 fieldName='creatorInformationMonacottoAddressMain' keys={['creatorInformation', asset, 'monacottoAddressMain']}
          face={words.monacottoAddressMain[state.language]} outerClass='widthMax' boxClass='box4 width96PC height4 marginTop1 ' textAreaClass='textArea1 height70PC'
        />
        {/* createrLink */}
        <TextArea2 fieldName='creatorInformationCreaterLink0Title' keys={['creatorInformation', asset, 'createrLink', 0, 'title']} face={words.createrLinkTitle[state.language] + 1}
          outerClass='widthMax' boxClass='box4 width96PC height4 marginTop1 ' textAreaClass='textArea1 height70PC'
        />
        <TextArea2 fieldName='creatorInformationCreaterLink0Url' keys={['creatorInformation', asset, 'createrLink', 0, 'url']} face={words.createrLinkUrl[state.language] + 1}
          outerClass='widthMax' boxClass='box4 width96PC height4 marginTop1 ' textAreaClass='textArea1 height70PC'
        />
        <TextArea2 fieldName='creatorInformationCreaterLink1Title' keys={['creatorInformation', asset, 'createrLink', 1, 'title']} face={words.createrLinkTitle[state.language] + 2}
          outerClass='widthMax' boxClass='box4 width96PC height4 marginTop1 ' textAreaClass='textArea1 height70PC'
        />
        <TextArea2 fieldName='creatorInformationCreaterLink1Url' keys={['creatorInformation', asset, 'createrLink', 1, 'url']} face={words.createrLinkUrl[state.language] + 2}
          outerClass='widthMax' boxClass='box4 width96PC height4 marginTop1 ' textAreaClass='textArea1 height70PC'
        />
        <TextArea2 fieldName='creatorInformationCreaterLink2Title' keys={['creatorInformation', asset, 'createrLink', 2, 'title']} face={words.createrLinkTitle[state.language] + 3}
          outerClass='widthMax' boxClass='box4 width96PC height4 marginTop1 ' textAreaClass='textArea1 height70PC'
        />
        <TextArea2 fieldName='creatorInformationCreaterLink2Url' keys={['creatorInformation', asset, 'createrLink', 2, 'url']} face={words.createrLinkUrl[state.language] + 3}
          outerClass='widthMax' boxClass='box4 width96PC height4 marginTop1 ' textAreaClass='textArea1 height70PC'
        />
        {/* reset button */}
        { resetButton }
        {/* register button */}
        { registerButton }
      </div>
    </div>
  );
}

export {
  Score,
  DuelSettingsButton,
  Item,
  Arrows,
  CardName,
  Quantity,
  MonsterDetail,
  ItemDetailSP,
  DuelText,
  FixedGrid,
  itemInGrid,
  CreatorInformation,
}
